import classNames from 'classnames';
import React from 'react';
import { Line, Tooltip } from '@mm/components';
import { ChannelIcon } from '../../../editor/features/liveChat/components/ChannelIcon';
import './ChannelSpecificDemarcator.pcss';

type Props = {
  webchat?: boolean;
  facebook?: boolean;
  addMarginAbove?: boolean;
  usedInSlideout?: boolean;
};
export const ChannelSpecificDemarcator = (props: Props) => {
  const { webchat, facebook, addMarginAbove, usedInSlideout } = props;

  const displayText = (() => {
    if (webchat && facebook) {
      return 'Supported on both Messenger & Webchat';
    }
    if (webchat) {
      return 'Supported on Webchat only';
    }
    if (facebook) {
      return 'Supported on Messenger only';
    }
  })();

  const lineClassName = classNames({
    'channel-specific-demarcator__line--with-margin-top': addMarginAbove,
  });
  if (usedInSlideout) {
    return null;
  }

  return (
    <div className="channel-specific-demarcator__container">
      <Tooltip title={displayText}>
        <Line className={lineClassName} textPosition="left">
          {facebook && (
            <ChannelIcon
              className="channel-specific-demarcator__channel-icon"
              channel="facebook"
            />
          )}
          {webchat && (
            <ChannelIcon
              className="channel-specific-demarcator__channel-icon"
              channel="webchat"
            />
          )}{' '}
        </Line>
      </Tooltip>
    </div>
  );
};
